
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_PREFERENCES } from "@/constants/notifications";
import { createDefaultPreferences } from "./createNotificationPreferences";

export const fetchNotificationPreferences = async (userId: string) => {
  console.log("Fetching notification preferences for user:", userId);
  
  const { data, error } = await supabase
    .from("notification_preferences")
    .select("*")
    .eq("user_id", userId)
    .maybeSingle();
  
  if (error) {
    console.error("Error fetching notification preferences:", error);
    throw error;
  }
  
  if (!data) {
    console.log("No preferences found, creating defaults");
    return createDefaultPreferences(userId);
  }
  
  console.log("Fetched notification preferences:", data);
  
  return {
    ...DEFAULT_PREFERENCES,
    ...data,
    account_notifications: data.account_notifications ?? true,
    system_notifications: data.system_notifications ?? true
  };
};
